<script lang="ts">
  import EditableText from './EditableText.svelte';
  import Provenance from './Provenance.svelte';
  import type { BlockKV, RenderCtx } from './types';

  let { block, ctx, editing = false, onchange }: {
    block: BlockKV;
    ctx: RenderCtx;
    editing?: boolean;
    onchange?: (next: BlockKV) => void;
  } = $props();

  function edit(index: number, value: string) {
    onchange?.({ ...block, items: block.items.map((it, i) => (i === index ? { ...it, value } : it)) });
  }
</script>

<dl class="brf-kv">
  {#each block.items as item, i (i)}
    <dt>{item.key}</dt>
    <dd><EditableText value={item.value} {editing} ariaLabel={item.key}
          onchange={(value) => edit(i, value)} /><Provenance
          provenance={item.provenance} sourceIds={item.source_ids} {ctx} /></dd>
  {/each}
</dl>
